import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = { number: string; title: string; description: string; borderless?: boolean };

const Wrapper = styled.div<{ borderless?: boolean }>`
  display: flex;
  flex-direction: column;
  /* ignore-color */
  border-inline-start: ${({ borderless }) => (borderless ? 'none' : `2px dashed ${colors.pepper16}`)};
  max-width: 455px;
  padding-block-end: 12px;
  margin-inline: 18px;
`;

const Number = styled(T.Heading5)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-weight: 600;
  font-size: 23px;
  background-color: ${colors.wolt8};
  color: ${colors.wolt100};
`;

const NumberWrapper = styled.div`
  background-color: ${cssThemedValue('surfaceMain')};
`;

const Title = styled(T.Title1)`
  font-weight: 700;
  margin-inline-start: 24px;
`;

const NumberTitleContainer = styled.div`
  display: flex;
  align-items: center;
  transform: translateX(-18px);
`;

const Description = styled(T.Body3)`
  margin-inline-start: 40px;
`;

const VerticalStep = ({ number, title, description, borderless }: Props) => {
  return (
    <Wrapper borderless={borderless}>
      <NumberTitleContainer>
        <NumberWrapper>
          <Number>{number}</Number>
        </NumberWrapper>

        <Title>{title}</Title>
      </NumberTitleContainer>

      <Description>{description}</Description>
    </Wrapper>
  );
};

export default VerticalStep;
